import(/* webpackMode: "eager" */ "C:\\dev\\okmoney\\src\\app\\life-plan\\page.tsx");
